module.exports = ".wfs-direct-pageNotFound {\n  text-align: center;\n  padding: 100px 0; }\n  .wfs-direct-pageNotFound .error-message {\n    font-size: 36px;\n    font-weight: normal; }\n  .wfs-direct-pageNotFound .error-code {\n    font-size: 170px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-not-found/containers/page-not-found.component.scss
// module id = ./src/app/pages/page-not-found/containers/page-not-found.component.scss
// module chunks = main